import React from 'react';

const testimonials = [
  {
    quote: "導入後、口コミ返信の時間が80%削減され、顧客満足度も向上しました。AI生成された返信は驚くほど自然で、私が書いたかのようです。",
    author: "山田 健太",
    position: "居酒屋「和心」オーナー",
    logo: "https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
  },
  {
    quote: "10店舗の美容院を運営していますが、すべての口コミに目を通すのは不可能でした。このサービスのおかげで、重要な口コミに素早く対応できるようになりました。",
    author: "佐藤 美咲",
    position: "美容室「Bloom」経営者",
    logo: "https://images.pexels.com/photos/1319459/pexels-photo-1319459.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
  },
  {
    quote: "クリニック5院の口コミを一元管理できるようになり、患者様からの声をサービス改善に活かせるようになりました。特に分析機能が非常に役立っています。",
    author: "鈴木 医師",
    position: "鈴木歯科医院 院長",
    logo: "https://images.pexels.com/photos/305566/pexels-photo-305566.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
  }
];

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="section">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl font-semibold">お客様の声</h2>
          <p className="max-w-2xl mx-auto text-lg">
            様々な業種のお客様に選ばれています
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-apple transition-all duration-300 hover:shadow-apple-lg"
            >
              <div className="mb-6 h-16 w-16 rounded-full overflow-hidden">
                <img 
                  src={testimonial.logo} 
                  alt={testimonial.author} 
                  className="w-full h-full object-cover"
                />
              </div>
              <blockquote className="mb-6">
                <p className="text-gray-600 italic">"{testimonial.quote}"</p>
              </blockquote>
              <div>
                <p className="font-medium">{testimonial.author}</p>
                <p className="text-gray-500 text-sm">{testimonial.position}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <a href="#pricing" className="btn btn-primary w-full sm:w-auto">
            今すぐ始める
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;